<template>
  <v-container fluid>
    <PageHeader :title="'Connect: ' + party.name" icon="mdi-link-variant" />
    <v-card class="elevation-1 card mt-4 pa-4 card-form">
      <v-card-text v-if="wizardStep == 1" class="wizard">
        <v-radio-group v-model="profileChoice">
          <v-radio label="Select a Profile with Existing Connection (Recommended)" :value="PROFILE_EXISTING" />
          <v-radio label="Create a New Profile (Advanced)" :value="PROFILE_NEW" />
        </v-radio-group>
      </v-card-text>
      <v-card-text v-if="wizardStep == 2 && profileChoice == 'existing'" class="wizard">
        <v-card-subtitle class="pa-4">Select an existing Profile</v-card-subtitle>
        <v-select
          :items="profiles"
          v-model="selectedProfileId"
          hide-details
          ref="textField"
          item-title="name"
          item-value="id"
          label="Profiles"
          :disabled="profiles.length == 1"
        ></v-select>
        <span v-if="profiles.length == 0">No profiles found. Please create a new profile</span>
      </v-card-text>
      <v-card-text v-if="wizardStep == 2 && profileChoice == 'new'" class="wizardParty">
        <v-card-subtitle class="pa-4">Create a new Profile</v-card-subtitle>
        <PartialProfile v-model:profileData="newProfile" />
      </v-card-text>
      <v-card-actions>
        <v-btn @click="previous()" :disabled="disablePrevious" size="large" color="primary" variant="flat"
          >Previous</v-btn
        >
        <v-btn @click="next()" :disabled="disableNext" size="large" color="primary" variant="flat">Next</v-btn>
        <v-spacer />
        <v-btn @click="cancel()" size="large" color="primary" variant="flat">Cancel</v-btn>
        <v-btn @click="accept()" size="large" color="primary" variant="flat" :disabled="disableAccept">Connect</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import Auth0Mixin from "../Auth0Mixin";
import PageHeader from "@/components/PageHeader.vue";
import orgUnitService from "@/services/admin/orgUnitService";
import PartialProfile from "@/components/PartialProfile.vue";
import partyService from "@/services/partyService";

const PROFILE_NEW = "new";
const PROFILE_EXISTING = "existing";

const requiredRule = [v => !!v || "Required"];
export default {
  name: "ConnectConnection",
  props: {
    id: [Number, String],
  },
  components: { PartialProfile, PageHeader },
  mixins: [Auth0Mixin],
  data() {
    return {
      party: {},
      wizardStep: 1,
      PROFILE_EXISTING: PROFILE_EXISTING,
      PROFILE_NEW: PROFILE_NEW,
      profileChoice: PROFILE_EXISTING,
      profiles: [],
      selectedProfileId: null,
      newProfile: {
        name: null,
        code: null,
      },
      ORGUNIT_FIELDS: [
        { label: "Name", attribute: "name", rules: requiredRule, type: "text" },
        {
          label: "Code",
          attribute: "code",
          rules: requiredRule,
          type: "text",
          altText:
            "Used to quickly separate and identify your profile. This can be anything that is used internally within your company do identify this division, or as simple as the word 'Default'",
        },
      ],
    };
  },
  methods: {
    async init() {
      this.party = await partyService.get(this.id);
      var profileData = await orgUnitService.getList();
      this.profiles = profileData.items;
      if (this.profiles.length == 1) {
        this.selectedProfileId = this.profiles[0].id;
      }
    },
    async showConfirmDialog() {
      let answer = await this.$root.$confirmDialog.open(
        "Accept",
        "By clicking continue, you agree that you have done any applicable due diligence specific to your company policies relevant to accepting documents from outside connections",
        "Continue"
      );

      return answer;
    },
    previous() {
      this.wizardStep--;
    },
    next() {
      this.wizardStep++;
    },
    async accept() {
      let answer = await this.showConfirmDialog();
      if (answer) {
        if (this.profileChoice == "existing") {
          await partyService.connect(this.id, this.selectedProfileId);
          this.$router.push("/admin/parties");
        } else {
          await partyService.connectAndCreateOrgUnit(this.id, this.newProfile);
          this.$router.push("/admin/parties");
        }
      }
    },
    cancel() {
      this.$router.push({ name: "ConnectionsList" });
    },
  },
  computed: {
    disableAccept() {
      if (this.wizardStep == 1) return true;
      if (this.wizardStep == 2 && this.profileChoice == "existing" && !this.selectedProfileId) return true;
      if (
        this.wizardStep == 2 &&
        this.profileChoice == "new" &&
        (!this.newProfile.name || !this.newProfile.name || !this.isMainAddressValid)
      )
        return true;
      return false;
    },
    disablePrevious() {
      return this.wizardStep == 1;
    },
    disableNext() {
      return this.wizardStep == 2;
    },
    isMainAddressValid() {
      let isAddressValid =
        (this.newProfile.addressLineOne &&
          this.newProfile.city &&
          this.newProfile.zipCode &&
          this.newProfile.country &&
          this.newProfile.state) ||
        (!this.newProfile.addressLineOne &&
          !this.newProfile.city &&
          !this.newProfile.zipCode &&
          !this.newProfile.country &&
          !this.newProfile.state);
      return isAddressValid;
    },
  },
};
</script>

<style scoped>
.wizard {
  height: 300px;
}
</style>
